<prlw-basis-best-price-mobile-price-options-ui
  [items]="items$ | async"
  (eventClick)="handleClick($event)"
  (eventClose)="eventClose.emit()"
></prlw-basis-best-price-mobile-price-options-ui>
